import styled from 'styled-components';
import { motion } from 'framer-motion';

const VIEW_REVEAL = '0.32s cubic-bezier(0.22, 1, 0.36, 1)';

export const ShowcaseCarouselContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 24px;
    min-height: 640px;
    width: 100%;
`

export const CarouselStage = styled.div`
    cursor: ${({ $grabbing }) => ($grabbing ? 'grabbing' : 'grab')};
    height: 520px;
    overflow: hidden;
    position: relative;
    touch-action: none;
    user-select: none;
    width: 100%;
`

export const ViewLabel = styled.span`
    color: #ffffff;
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.16em;
    pointer-events: none;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.95);
`

export const ViewOverlay = styled.div`
    align-items: center;
    display: flex;
    inset: 0;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: ${({ $upright }) => ($upright ? 'rotate(-90deg)' : 'none')};
    transition: opacity ${VIEW_REVEAL};
    z-index: 2;
`

export const CarouselCard = styled(motion.div)`
    background: transparent;
    border: none;
    cursor: pointer;
    left: 50%;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    transform-origin: center center;

    img {
        height: 100%;
        left: 0;
        object-fit: contain;
        pointer-events: none;
        position: absolute;
        top: 0;
        filter: blur(0px) brightness(1) drop-shadow(0 16px 32px rgba(0, 0, 0, 0.35));
        transition: filter ${VIEW_REVEAL};
        width: 100%;
    }

    ${({ $isCenter, $hovered }) => $isCenter && $hovered && `
        img {
            filter: blur(2px) brightness(0.55) drop-shadow(0 16px 32px rgba(0, 0, 0, 0.35));
        }

        ${ViewOverlay} {
            opacity: 1;
        }
    `}

    ${({ $isCenter }) => $isCenter && `
        &:focus-visible img {
            filter: blur(2px) brightness(0.55) drop-shadow(0 16px 32px rgba(0, 0, 0, 0.35));
        }

        &:focus-visible ${ViewOverlay} {
            opacity: 1;
        }
    `}
`

export const PositionRail = styled.div`
    height: 4px;
    margin: 4px 0 18px;
    position: relative;
    width: min(220px, 52%);
`

export const PositionTrack = styled.div`
    background: rgba(255, 255, 255, 0.18);
    border-radius: 4px;
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
    top: 1px;
`

export const PositionThumb = styled.div`
    background: #ffffff;
    border-radius: 4px;
    height: 4px;
    position: absolute;
    top: 0;
    width: 28px;
`

export const CaptionViewport = styled.div`
    box-sizing: border-box;
    display: grid;
    justify-items: center;
    min-width: 0;
    padding: 0 8px;
    width: 100%;
`

export const CaptionSlide = styled(motion.div)`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    grid-area: 1 / 1;
    justify-self: stretch;
    max-width: 100%;
    min-width: 0;
    text-align: center;
    width: 100%;
`

export const PlayerName = styled.h2`
    color: #D0D0D0;
    font-family: 'Roboto', sans-serif;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.12em;
    line-height: 24px;
`

export const TeamName = styled.p`
    color: #FFFFFF;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.22em;
    opacity: 0.5;
    text-transform: uppercase;
`

export const AttributeRow = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    gap: 6px;
    justify-content: safe center;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;
    width: 100%;

    &::-webkit-scrollbar {
        display: none;
    }

    h5 {
        flex-shrink: 0;
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: center;
        overflow-x: visible;
    }
`

export const CarouselEmpty = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    min-height: 360px;
`